<div class="row gx-0 headline-container" #headlineContainer>
  <div class="col-12 header">
    <h2 class="h5">{{headline}}</h2>
    <p><ng-content></ng-content></p>
  </div>
</div>